import classes from "./styles.module.scss";
import React, { Props, Component } from "react";
import classNames from "classnames";

interface LayouterProps extends Props<Component> {
  staticFooter?: boolean;
}

/**
 * The layouter is a grid driven layout handler
 * @param props
 */
function Layouter(props: LayouterProps) {
  const layouterClass = classNames(
    props.staticFooter ? classes.staticFooter : "",
    classes.Layouter
  );
  return (
    <div className={layouterClass} id={"cspi_layouter"}>
      {props.children}
    </div>
  );
}

export default Layouter;
